import { Component } from '@angular/core';
import { User } from 'src/app/models/user.model';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { Role } from 'src/app/models/role.model';
import { UserAccessTypeService } from 'src/app/services/user-access-type/user-access-type.service';
import { Company } from 'src/app/models/company.model';
import { CompanysService } from 'src/app/services/companies/companies.service';
import { RoleService } from 'src/app/services/role/role.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { isNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss'],
})
export class AddUserComponent {
  [x: string]: any;
  companyId: number;
  AddUserForm!: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private UserService: UserService,
    private roleService: RoleService,
    private companysService: CompanysService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder
  ) {
    this.route.queryParams.subscribe((params) => {
      this.companyId = params['companyId'];
    });
  }

  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  dateNow: Date = new Date();
  roles: Role[] = [];
  companys: Company[] = [];
  submitted = false;
  addUserRequest: User = new User();
  containsUsername: boolean = false;
  isCommonPassword: boolean = false;
  containsConsecutiveNumbers: boolean = false;
  containsRepeatingChars: boolean = false;
  loggedInuserRole: any;
  CompanyId: string;
  userDetails2: User = new User();
  responseUser: any;
  countDigits: number;
   d1: number;
   d2: number;
   d3: number; 
   c2: boolean; 
   c3: boolean; 
   checkContinuousNumbers:boolean;
   check:number;
   checkD:number;
  ngOnInit(): void {
    this.addUserRequest.RoleId = '';
    this.CompanyId = '0';
    this.loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if (
      this.loggedInuserRole.role == 'Standard User' ||
      this.loggedInuserRole.role == 'Regional User'
    ) {
      this.logout();
    }
    console.log(this.companyId);
    this.addUserRequest.CompanyId = this.companyId;
    this.roleService.getAllRoleType().subscribe({
      next: (roles) => {
        this.roles = roles;
       
        if (this.loggedInuserRole.role == 'Internal User') {
          this.roles = roles.filter(
            (role: Role) => role.Name === 'Standard User'
          );
          this.addUserRequest.RoleId = this.roles[0].Id;
          this.addUserRequest.RoleName = this.roles[0].Name;
        }
      },
      error: (response) => {
       
      },
    });

    this.companysService.getAllCompanys().subscribe({
      next: (companys) => {
        this.companys = companys;
       
      },
      error: (response) => {
       
      },
    });

    this.AddUserForm = this.formBuilder.group({
      Username: ['', Validators.required],
      FirstName: ['', Validators.required],
      LastName: ['', Validators.required],
      UserEmail: ['', [Validators.required, Validators.email]],
      Password: ['', [Validators.required, Validators.minLength(7)]],
      //Password: [{ value: '', disabled: true }, [Validators.required, Validators.minLength(7)]],
    });
  }

  validateUsername() {
    this.submitted = true; // Trigger validation status
    let Username = this.AddUserForm.value.Username
    if (Username.length > 1) {
      this.AddUserForm.get('Password')?.validator.apply;
    }
    /* else {
      //this.AddUserForm.get('Password')?.disable();
      //this.AddUserForm.get('Password')?.validator.apply;
    } */
  }

  validateFirstName() {
    this.submitted = true; // Trigger validation status
  }

  validateLastName() {
    this.submitted = true; // Trigger validation status
  }

  validateEmail() {
    this.submitted = true; // Trigger validation status
  }
   onlyDigits(s) 
   {
    let count=0;
    let subConsecutive;
    for (let i = s.length-1 ; i >= 0; i--) 
      {
        const d = s.charCodeAt(i);
        if (d >= 48 && d <= 57)
          {
            
              count++;
              //subConsecutive(subConsecutive.length-1)=d;
              if(count==3)
              {
                break;
              }
           
          }
          /*  else
          {
            count=0;
          }  */
          
         
         
       
    
    }
    return count;
  }
 

  validatePassword(e) {
    

    let password = e.target.value;
    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[^a-zA-Z0-9]/.test(password);
    const isMinLength = password.length >= 7;
    this.containsUsername = password
      .toLowerCase()
      .includes(this.AddUserForm.get('Username').value.toLowerCase());
    this.isCommonPassword = password.toLowerCase() === 'password';
    //this.containsConsecutiveNumbers = /\d{3,}/.test(password); // Check for consecutive numbers
   //this.containsConsecutiveNumbers= /([0-9A-z])\1\1\1/.test(password);
   this.countDigits=this.onlyDigits(password);
   console.log(this.containsConsecutiveNumbers);
   this.check=0;
   if(this.countDigits > 2)
   {
      for(let i = password.length - 1; i >= 0; i--)
      {

        const d = password.charCodeAt(i);
        if (d >= 48 && d <= 57) 
        {
          //1A2
          
          
          
          this.check++;
          if(this.check==1)
          {
            this.d1=d;
          }
          if(this.check==2)
          {
            this.d2=d;
          }
          if(this.check==3)
          {
            this.d3=d;
          }
          if(this.check>=3)
            {
              break;
            }
        
        }
        else
        {
          this.check=0;
         if(this.d1 !=null)
         {
          this.d1 == null;
         }
         if(this.d2 !=null)
         {
          this.d2 == null;
         }
         if(this.d3!=null)
         {
          this.d3 == null;
         }
         this.containsConsecutiveNumbers=false;
        }
      }
         if(this.d1==this.d2 && this.d2==this.d3 && this.d1==this.d3)
          {
            this.containsConsecutiveNumbers=true;
          }
          else if((this.d2 - this.d3 ==1 && this.d1-this.d3==2) ||(this.d1 - this.d2 == -1 && this.d1 - this.d3 == -2))
          {
            
              this.containsConsecutiveNumbers=true;
          }
         
          else
          {
            this.containsConsecutiveNumbers=false;
             this.countDigits=0; 
          }
          
   }
   else
   {
    this.containsConsecutiveNumbers=false;
    this.countDigits=0;
   }
    this.containsRepeatingChars = /([a-zA-Z0-9])\1{2,}/.test(password); // Check for repeating characters
    
    
    
    (document.getElementById('lowercaseCheck') as HTMLInputElement).checked =
      hasLowercase;
    (document.getElementById('uppercaseCheck') as HTMLInputElement).checked =
      hasUppercase;
    (document.getElementById('numberCheck') as HTMLInputElement).checked =
      hasNumber;
    (document.getElementById('specialCharCheck') as HTMLInputElement).checked =
      hasSpecialChar;
    (document.getElementById('minLengthCheck') as HTMLInputElement).checked =
      isMinLength;
      if (this.AddUserForm.value.Username.length > 1) {
        this.AddUserForm.get('Password')?.validator.apply;
      }
  }

  updateRoleName(event: Event) {
    const selectedRoleId = (event.target as HTMLSelectElement).value;
    const selectedRole = this.roles.find((role) => role.Id === selectedRoleId);

    if (selectedRole) {
      this.addUserRequest.RoleName = selectedRole.Name;
    }
  }

  addUser() {
    this.submitted = true;

    // Check if the form is valid
    if (this.AddUserForm.valid && this.isPasswordValid()) {
      const dateNowISO = this.dateNow.toISOString();

      this.addUserRequest.UserName = this.AddUserForm.value.Username;
      this.addUserRequest.FirstName = this.AddUserForm.value.FirstName;
      this.addUserRequest.LastName = this.AddUserForm.value.LastName;
      this.addUserRequest.Email = this.AddUserForm.value.UserEmail;
      this.addUserRequest.Password = this.AddUserForm.value.Password;
      this.addUserRequest.UserId = '';
      this.addUserRequest.PhoneNumber = '1234567890';
      this.addUserRequest.Type = '1';
      this.addUserRequest.CompanyId = Number(this.CompanyId);
     
      console.log(this.addUserRequest);
      this.UserService.addUser(this.addUserRequest).subscribe({
        next: (User) => {
          console.log(User);
          var id = btoa(User.UserId);
          this.toastr.success('User Added Successfully.', 'Information');
          if (this.loggedInuserRole.role == 'Internal User') {
            this.router.navigate(['/dashboard']);
          } else {
            this.router.navigate(['/component/user/edit/' + id]);
          }
        },
        error: (response) => {
          if (response.error.length > 0) {
            this.toastr.error(response.error, 'Error');
          } else {
            this.toastr.error('Error While Creating User.', 'Error');
          }
        },
      });
    } else {
      // Form is not valid, show error
      this.toastr.error(
        'Please validate all fields, including password.',
        'Error'
      );
    }
  }

  isPasswordValid(): boolean {
    const password = this.AddUserForm.value.Password;
    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[^a-zA-Z0-9]/.test(password);
    const isMinLength = password.length >= 7;
    (this.AddUserForm.value.UserName !='')
    const containsUsername = password
    
      .toLowerCase()
      .includes(this.AddUserForm.get('Username').value.toLowerCase());
    const isCommonPassword = password.toLowerCase() === 'password';
    //const containsConsecutiveNumbers = /\d{3,}/.test(password); // Check for consecutive numbers
    const containsRepeatingChars = /([a-zA-Z0-9])\1{2,}/.test(password); // Check for repeating characters

    return (
      hasLowercase &&
      hasUppercase &&
      hasNumber &&
      hasSpecialChar &&
      isMinLength &&
      //!containsConsecutiveNumbers &&
      !this.containsConsecutiveNumbers &&
      !containsUsername &&
      !containsRepeatingChars &&
      !isCommonPassword
    );
  }

  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }
}
